import { render, staticRenderFns } from "./CustomBranding.vue?vue&type=template&id=58b5c19f&scoped=true&"
import script from "./CustomBranding.vue?vue&type=script&lang=js&"
export * from "./CustomBranding.vue?vue&type=script&lang=js&"
import style0 from "./CustomBranding.vue?vue&type=style&index=0&id=58b5c19f&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/screen.css?vue&type=style&index=1&id=58b5c19f&prod&scoped=true&lang=css&"
import style2 from "./CustomBranding.vue?vue&type=style&index=2&id=58b5c19f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5c19f",
  null
  
)

export default component.exports